import { useEffect, useState } from "react";
import { Empty, ProgramCard } from "../../../components/ui";
import AuthPrimaryButton from "../../../components/ui/AuthPrimaryButton";
import {
  modalBody,
  modalCloseBtn,
  modalSecondaryBtn,
  modalSubtitle,
  modalTitle,
} from "../../../components/ui/modalDesign";
import UserService from "../../../services/user.service";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/rootReducer";
import {
  setCart,
  setRenewal,
  setResume,
} from "../../../redux/reducers/userSlice";
import { X } from "lucide-react";
import {
  ADVANCED_PACKAGE_LEVEL,
  isAdvancedAge,
  resolvePackageForChild,
} from "../../../utils/constants";

interface Props {
  handlePrevious?: () => void;
  childInfo: any;
  setSuccessModal?: any;
  closeRegTab: () => void;
  isRenewing?: boolean;
}

const divStyle = `relative ${modalBody}`;

export default function RegSubModal({
  childInfo,
  setSuccessModal,
  closeRegTab,
  isRenewing,
}: Props) {
  const userInfo: any = useSelector((state: RootState) => state.auth.userInfo);
  const userService = new UserService();
  const dispatch = useDispatch();

  const [selected, setSelected] = useState<any>(null);
  const [programArr, setProgramArr] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  const getPackages = async () => {
    setLoading(true);
    try {
      const response = await userService.getAllPackages();
      setLoading(false);
      if (!response.status) {
        toast.error(response.message);
        return;
      }
      //check programs
      const hasPrograms = Array.isArray(childInfo?.programs);
      const hasProgramAndPackages =
        hasPrograms && childInfo?.programs[0].hasOwnProperty("package");
      // Next package tier comes from API (`childInfo.level`), so "No" on cohort completion repeats the same tier.
      // Age >16 always uses Advanced Level 14 (no special programs).
      const targetPackageLevel = isAdvancedAge(childInfo.age)
        ? ADVANCED_PACKAGE_LEVEL
        : hasProgramAndPackages
          ? Number(childInfo.level) || 1
          : 1;
      const matched = resolvePackageForChild(
        response?.data || [],
        childInfo.age,
        targetPackageLevel
      );
      const programFilter = matched ? [matched] : [];
      if (programFilter.length > 0) {
        setSelected(programFilter[0]?.id);
      }
      setProgramArr(programFilter);
    } catch (err: any) {
      setLoading(false);
      toast.error(err?.message);
      return;
    }
    return false;
  };

  //console.log(childInfo, 'childInfo')

    const handleSubmit = async () => {

        if (selected) {
            console.log(isRenewing)
            console.log(childInfo)
            console.log(userInfo?.timeOffset)
            //filter options
            const isProgramsAvailable = Array.isArray(childInfo?.programs)
            const isRenewConfirm = isProgramsAvailable && isRenewing
            //const packageId = isRenewing ? childInfo?.programs[0]?.package?.id : selected;
            const packageId = selected;
            const timeOffset = isRenewing ? (childInfo?.programs?childInfo?.programs[0]?.timeOffset: userInfo?.timeOffset) : userInfo?.timeOffset;
            const day = isRenewConfirm ? childInfo?.programs[0]?.day : (childInfo?.selectedDay?.value.toString() || childInfo?.programs[0]?.day.toString());
            const level = isAdvancedAge(childInfo?.age)
                ? ADVANCED_PACKAGE_LEVEL
                : (isRenewConfirm ? childInfo.level : 1);
            const time = isRenewConfirm ? childInfo.programs[0]?.time : (childInfo?.selectedTime?.value.toString() || childInfo.programs[0]?.time.toString());
            const childId = childInfo.id;
            const payload = {packageId, timeOffset, day, time, level, cohortId: (childInfo?.cohortId || childInfo?.programs[0]?.cohortId)}

      setSubmitLoading(true);
      try {
        const response = await userService.addProgram(payload, childId);
        setSubmitLoading(false);
        if (!response.status) {
          toast.error(response.message);
          dispatch(setCart(false));
          return;
        }
        setSuccessModal();
        closeRegTab();
        dispatch(setCart(true));
        dispatch(setRenewal(null));
        dispatch(setResume(null));
      } catch (err: any) {
        setSubmitLoading(false);
        toast.error(err.message);
      }
    }
    return false;
  };

  useEffect(() => {
    getPackages();
  }, []);

    const disabled = !selected;
    // const disabled = !selected ? true : false;

  return (
    <div className={divStyle}>
      <button type="button" aria-label="Close" className={modalCloseBtn} onClick={closeRegTab}>
        <X size={18} />
      </button>

      <div className="mb-5 pr-8 text-center sm:mb-6">
        <h1 className={modalTitle}>Available Program</h1>
        <p className={modalSubtitle}>Confirm the program matched to your child&apos;s age, then submit.</p>
      </div>

      <div className="mx-auto w-full">
        {programArr.length > 0 ? (
          programArr.map((item: any) => (
            <ProgramCard
              id={item.id}
              key={item.id}
              price={item.amount}
              program={item.title}
              description={item.description}
              minAge={item.minAge}
              maxAge={item.maxAge}
              duration={item.weekDuration}
              altPrice={item.altAmount}
              country={userInfo.country}
            />
          ))
        ) : (
          <Empty
            text={
              <>
                There is no available package for this age group, kindly contact
                the admin via{" "}
                <a href="tel:+18337371275" target="_blank" rel="noreferrer">
                  +1-8337371275
                </a>{" "}
                or{" "}
                <a href="https://t.me/+kRUSHEc8S_thYzJk" target="_blank" rel="noreferrer">
                  Telegram
                </a>
              </>
            }
          />
        )}
      </div>

      <div className={`mt-6 grid grid-cols-1 gap-3 ${!isRenewing ? "sm:grid-cols-2" : ""}`}>
        {!isRenewing && (
          <button type="button" onClick={closeRegTab} className={modalSecondaryBtn}>
            Cancel
          </button>
        )}
        <AuthPrimaryButton
          type="button"
          loading={submitLoading}
          disabled={disabled}
          showArrow={false}
          onClick={handleSubmit}
          className={!isRenewing ? "" : "sm:col-span-1"}
        >
          Submit
        </AuthPrimaryButton>
      </div>
    </div>
  );
}
